import { createCrudContext } from "./_lib/createCrudContext";

const { Provider, useValue } = createCrudContext({
  name: "climate",
  legacy: {
    data: "climate",
    count: "count",
    fetch: "fetchClimates",
    create: "createOneClimate",
    update: "updateClimate",
    remove: "deleteClimate",
    updateState: "updateClimateState",
  },
});

export const ClimateProvider = Provider;
export const useClimateContext = useValue;
